import { render, staticRenderFns } from "./SubscriptionLoader.vue?vue&type=template&id=3bd10e93"
import script from "./SubscriptionLoader.vue?vue&type=script&lang=js"
export * from "./SubscriptionLoader.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionLoader.vue?vue&type=style&index=0&id=3bd10e93&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd10e93')) {
      api.createRecord('3bd10e93', component.options)
    } else {
      api.reload('3bd10e93', component.options)
    }
    module.hot.accept("./SubscriptionLoader.vue?vue&type=template&id=3bd10e93", function () {
      api.rerender('3bd10e93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/pricing/components/SubscriptionLoader.vue"
export default component.exports